import React from 'react';
import { SummaryRow } from '../../../../Summary/SummaryRow';
import { VQ } from '../../../../../store/student/types';
import { IVisaPrepForm, IAdditionalPassport } from '../../../../../types';
import { boolToYesNo } from '../../../../../utilities/formatting';
import { Box } from '@chakra-ui/react';
import { SummaryGroup } from '../../../../Summary/SummaryGroup';

function VisaPrepAdditionalPersonalInfo(props: IVisaPrepForm) {
  const renderAdditionalPassports = () => {
    const allAdditionalPassports: React.ReactNode[] = [];
    if (props.additionalPassports && props.additionalPassports.length) {
      props.additionalPassports.forEach((passport: IAdditionalPassport, i: number) => {
        allAdditionalPassports.push(
          <SummaryGroup title={`Additional passport ${i + 1}`} key={i}>
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.ADDITIONAL_PASSPORT_PASSPORT_NUMBER}-${i}`}
              label="Current passport or travel document number"
              value={passport.docNumber}
            />
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.ADDITIONAL_PASSPORT_PLACE_OF_ISSUE}-${i}`}
              label="Place of issue"
              value={passport.placeOfIssue}
            />
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.ADDITIONAL_PASSPORT_ISSUING_AUTHORITY}-${i}`}
              value={passport.issuingAuthority}
              label="Issuing authority"
            />
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.ADDITIONAL_PASSPORT_DATE_OF_ISSUE}-${i}`}
              label="Date of Issue"
              value={passport.issueDate}
            />
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.ADDITIONAL_PASSPORT_DATE_OF_EXPIRY}-${i}`}
              label="Date of Expiry"
              value={passport.expiryDate}
            />
          </SummaryGroup>,
        );
      });
    }
    return allAdditionalPassports;
  };
  return (
    <>
      <SummaryRow
        className={'visa-summary'}
        key={VQ.HAS_ADDITIONAL_PASSPORTS}
        label="Has additional passports"
        fullLabel={`Have you had any other passports in the last 10 years?`}
        value={boolToYesNo(props.hasAdditionalPassports)}
      />
      {props.hasAdditionalPassports ? (
        <>
          <SummaryRow
            className={'visa-summary'}
            label="How many additional passports?"
            value={props.additionalPassports?.length}
          />

          <Box as="ol" pl={8} key={'additional-passports'}>
            {renderAdditionalPassports()}
          </Box>
        </>
      ) : null}
    </>
  );
}

export default VisaPrepAdditionalPersonalInfo;
